import React, { useContext, useEffect, useState } from "react";
import SupplierContext from "../../../../contexts/SupplierContext";
import UserContext from "../../../../contexts/UserContext";
import IXeroDisconnectDTO from "../../../../models/DTO/IXeroDisconnectDTO";
import IXeroOauthStartDTO from "../../../../models/DTO/IXeroOauthStartDTO";
import IXeroOnDisconnectDTO from "../../../../models/DTO/IXeroOnDisconnectDTO";
import IXeroOnOauthStartDTO from "../../../../models/DTO/IXeroOnOauthStartDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import xeroLogo from "../../../../assets/images/xero/Logo - Blue.png";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwPill from "../../../shared/OwPill/OwPill";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
};

export const XeroConnect: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const [isDisconnectActive, setIsDisconnectActive] = useState<boolean>(false);

    const { has_xero } = supplierModel.Supplier_Integration;

    useEffect(() => {
        props.socket.on(EndpointsEnum.XeroOnAuthStart, xeroOnOauthStart);
        props.socket.on(EndpointsEnum.XeroOnDisconnect, onDisconnect);

        return () => {
            props.socket.removeListener(EndpointsEnum.XeroOnAuthStart, xeroOnOauthStart);
            props.socket.removeListener(EndpointsEnum.XeroOnDisconnect, onDisconnect);
        };
    }, []);

    const connect = () => {
        const payload: IXeroOauthStartDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        props.socket.emit(EndpointsEnum.XeroOauthStart, payload);
    };

    const xeroOnOauthStart = (data: IXeroOnOauthStartDTO) => {
        // console.log(data);
        // @ts-expect-error
        window.location = data.url;
    };

    const getConnectedStatus = () => {
        return (
            <div className={"ms-auto"}>
                {!has_xero ? (
                    <OwButton title={"connect"} fn={connect} />
                ) : (
                    <OwBadge title={"connected"} leftIconClass={"fas fa-check"} bgColor={"bg-success"} />
                )}
            </div>
        );
    };

    const disconnect = () => {
        const payload: IXeroDisconnectDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        props.socket.emit(EndpointsEnum.XeroDisconnect, payload);

        setIsDisconnectActive(true);
    };

    const onDisconnect = (data: IXeroOnDisconnectDTO) => {
        setIsDisconnectActive(false);
    };

    const getMainContent = () => {
        return (
            <div>
                <OwButton
                    leftIconClass={"fas fa-unlink"}
                    className={"btn btn-danger"}
                    title={"disconnect"}
                    fn={disconnect}
                    active={isDisconnectActive}
                    disableOnActive={true}
                />
            </div>
        );
    };

    return (
        <div className={"XeroConnect"}>
            <OwAccordion
                hideChevron={!has_xero}
                leftImage={xeroLogo}
                leftImageHeight={50}
                leftImageAlt={"Xero"}
                rightElem={getConnectedStatus()}>
                {getMainContent()}
            </OwAccordion>
        </div>
    );
};
